var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"folder-icon-wrapper is-clickeable",on:{"click":function($event){return _vm.goingTo()}}},[_c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('img',_vm._g(_vm._b({attrs:{"src":require("@/assets/icons/folder.svg")}},'img',attrs,false),on))]}}])},[_c('span',[_vm._v(_vm._s(_vm.tooltipText))])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }